module.exports = __webpack_public_path__ + "static/media/3-2.2800f3d9.png";